/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */

export type TableGranularityEnum = typeof TableGranularityEnum[keyof typeof TableGranularityEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TableGranularityEnum = {
  closing: 'closing',
  entity: 'entity',
  event: 'event',
  external_id: 'external_id',
  fund: 'fund',
  fund_family: 'fund_family',
  portfolio: 'portfolio',
  investment: 'investment',
  investor_class: 'investor_class',
  investor: 'investor',
  investor_entity: 'investor_entity',
  security_ownership: 'security_ownership',
  transaction: 'transaction',
  transaction_code: 'transaction_code',
  credit_facility: 'credit_facility',
  total: 'total',
  uses: 'uses',
  reports: 'reports',
  waterfall: 'waterfall',
  credit_facility_borrowing_base_group: 'credit_facility_borrowing_base_group',
  empty: 'empty',
  contact: 'contact',
} as const;
